import React from "react";
import { Badge } from "../../../ui/badge";
import {
  holdReason,
  importStatusMeta,
  isAdminHeld,
  statusLabel,
  typeLabel,
} from "./researchLibraryFormat";

/** Live / Held, with the hold reason as a tooltip (admin holds are marked). */
export const DialogueStatusBadge = ({ dialogue, className }) => {
  const live = Boolean(dialogue?.runtime_attachable);
  const reason = holdReason(dialogue);
  const tooltip = live
    ? "Attachable at runtime"
    : `${isAdminHeld(dialogue) ? "Admin hold" : "Release rule"}: ${
        reason || "no reason recorded"
      }`;
  return (
    <Badge variant={live ? "success" : "warning"} className={className} title={tooltip}>
      {statusLabel(dialogue)}
      {!live && isAdminHeld(dialogue) ? " (admin)" : ""}
    </Badge>
  );
};

export const TypeBadge = ({ type, className }) => (
  <Badge
    variant={String(type || "").toUpperCase() === "COMPOSITE" ? "secondary" : "outline"}
    className={className}
  >
    {typeLabel(type)}
  </Badge>
);

export const ImportStatusBadge = ({ status, className }) => {
  const meta = importStatusMeta(status);
  return (
    <Badge variant={meta.variant} className={className}>
      {meta.label}
    </Badge>
  );
};
